export default __webpack_public_path__ + "static/media/2_Pagos smart_1636x1341.650e2f1a.png";